<template>
  <div class="text-textColor">
    <transition name="fade">
      <div v-if="loading">
        <Loader />
      </div>
    </transition>
    <transition name="fade">
      <div
        v-if="showAddAnnouncemnt"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full"
      >
        <div
          class="fixed center-h-v bg-white rounded-md shadow-2xl sm:w-1/2 w-full"
        >
          <div class="flex justify-between items-center border-b-1.5 p-3">
            <p class="text-base">Add Announcemnt</p>
            <img
              v-if="!loading"
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="close()"
            />
          </div>
          <form @submit.prevent="create">
            <transition name="fade">
              <div
                v-if="create_error"
                class="p-1 text-center text-sm w-full bg-yellow-200"
              >
                {{ create_error }}
              </div>
            </transition>
            <transition name="fade">
              <div
                v-if="create_success"
                class="p-1 text-center text-sm w-full bg-green-200"
              >
                {{ create_success }}
              </div>
            </transition>
            <div class="grid grid-cols-1 p-4 gap-2">
              <div class="text-sm">
                <label class="block pb-1">Title</label>
                <input
                  v-model="info.Title"
                  type="text"
                  class="p-2 bg-gray-200 rounded-full w-full"
                  placeholder="New System Training"
                  required
                />
              </div>
              <div class="span">
                <label>Announcement</label>
                <textarea
                  v-model="info.Content"
                  class="p-2 bg-gray-200 rounded-xl w-full"
                  rows="5"
                  required
                ></textarea>
              </div>
            </div>
            <div class="grid grid-cols-2 p-4 gap-3">
              <div class="text-sm">
                <label class="block pb-1">Visibility</label>
                <select
                  class="p-2 bg-gray-200 rounded-full w-full"
                  v-model="info.Visibility"
                  :required="info.Status == 2"
                >
                  <option value="1">Public</option>
                  <option value="2">Department</option>
                </select>
              </div>

              <div class="text-sm" v-if="info.Visibility == 2">
                <label class="block pb-1">Department</label>

                <el-select
                  filterable
                  class="bg-gray-200 rounded-full w-full border-none"
                  v-model="info.DepartmentId"
                  placeholder="Select a type"
                >
                  <el-option
                    v-for="department in departments"
                    :key="department.DepartmentId"
                    :label="department.Name"
                    :value="department.DepartmentId"
                  >
                  </el-option>
                </el-select>
              </div>

              <div class="text-sm">
                <label class="block pb-1">Publication Date</label>
                <input
                  v-model="info.PublicationDate"
                  type="date"
                  class="p-2 bg-gray-200 rounded-full w-full"
                  placeholder="Deadline"
                  :required="info.Status == 1"
                />
              </div>
              <div class="text-sm">
                <label class="block pb-1">Expiration Date</label>
                <input
                  v-model="info.ExpirationDate"
                  type="date"
                  class="p-2 bg-gray-200 rounded-full w-full"
                  placeholder="Deadline"
                />
              </div>

              <div class="text-sm">
                <label class="block pb-1">Status</label>
                <select
                  class="p-2 bg-gray-200 rounded-full w-full"
                  v-model="info.Status"
                >
                  <option value="0">Draft</option>
                  <option value="1">Published</option>
                  <option value="2">Archived</option>
                </select>
              </div>

              <div class="text-sm">
                <label class="block pb-1">Priority</label>
                <select
                  class="p-2 bg-gray-200 rounded-full w-full"
                  v-model="info.Priority"
                >
                  <option value="0">Low</option>
                  <option value="1">Medium</option>
                  <option value="2">High</option>
                </select>
              </div>
            </div>

            <div class="flex justify-end p-5">
              <button
                type="submit"
                class="bg-primary rounded-full px-10 text-sm text-white py-2"
              >
                Create
              </button>
            </div>
          </form>
        </div>
      </div>
      >
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import Loader from "../loader/loader.vue";
export default {
  name: "AddAnnouncemnt",
  props: ["showAddAnnouncemnt", "reload"],
  components: { Loader },
  data() {
    return {
      loading: false,
      create_error: null,
      create_success: null,
      departments: [],
      info: {
        Title: "",
        Content: "",
        PublicationDate: "2023-08-25T10:12:47.129Z",
        ExpirationDate: "2023-08-25T10:12:47.129Z",
        Visibility: 0,
        DepartmentId: "",
        Status: 1, // 1 is
        Priority: 0,
      },
    };
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
  },
  created() {
    this.getDepartments();
  },
  methods: {
    close() {
      this.$emit("close");
    },
    async create() {
      const url = `${this.getOrganization}/announcement/v1/create`;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };

      try {
        this.info.Visibility = parseInt(this.info.Visibility);
        this.info.Status = parseInt(this.info.Status);
        this.info.Priority = parseInt(this.info.Priority);
        const response = await axios.post(url, this.info, options);
        if (response.data.StatusCode === 200) {
          this.create_success = response.data.StatusMessage;

          setTimeout(() => {
            this.$emit("close");
            this.reload();
            this.create_success = null;
          }, 3000);
        } else {
          this.create_error = response.data.StatusMessage;
          setTimeout(() => {
            this.create_error = null;
          }, 3000);
        }
      } catch (error) {
        this.create_error = null;

        setTimeout(() => {
          this.create_error = null;
        }, 3000);
      }
    },
    // /{organization}/setup/department/v1/request
    getDepartments() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/department/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              //console.log(response.data.Data);
              this.departments = response.data.Data;
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
